// The feed session as the worker states it, in the shape of feedSession(); the local calendar is the
// fallback when /session has not answered, is older than ten minutes, or has run past "until".
import type { SessionPayload } from '../api/types';
import { feedSession, type FeedSession } from './calendar';
import { parseTs } from './format';

export interface SessionSample { payload: SessionPayload; at: number }

export function sessionNow(sample: SessionSample | null, now: number = Date.now(), maxAgeMs = 600000): FeedSession {
  if (sample && now - sample.at < maxAgeMs) {
    const since = parseTs(sample.payload.since), until = parseTs(sample.payload.until);
    if (since && until && until.getTime() > now) {
      return sample.payload.state === 'live'
        ? { live: true, startedAt: since, endsAt: until, api: true }
        : { live: false, frozenSince: since, resumesAt: until, reason: sample.payload.reason, api: true };
    }
  }
  return feedSession(new Date(now));
}
